<template>
  <ul class="inner-navigation">
    <li v-for="(link, idx) in links" :key="idx">
      <router-link :to="link.to" active-class="active">
        {{ link.label }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Navigation',

  props: {
    links: Array
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.inner-navigation {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: flex-start;

  li {
    margin-right: 30px;
    padding: 8px 0;

    a {
      display: block;
      font-size: 1.6em;
      font-weight: normal;
      width: 100%;
      color: $light-link-color;
      border-bottom: 2px solid transparent;

      &:hover,
      &.active {
        color: $green;

        &.active {
          border-bottom-color: $green-active;
        }
      }
    }
  }
}
</style>
